import Masonry from 'masonry-layout';

export default class QuestionAnswer {
	constructor() {
		this.qaItems = document.querySelectorAll('[data-question-answer]');
        this.qaCards = document.querySelector('[data-questions-answers-cards]');
        this.qaCard = document.querySelectorAll('[data-questions-answers-card]');

		if (this.qaItems.length <= 0) {
			return;
		}

        const msnry = new Masonry( this.qaCards, {
			itemSelector: '.c-card-question-answer',
			columnWidth: '.grid-sizer',
			gutter: 70,
			percentPosition: true,
			transitionDuration: 0,
			horizontalOrder: true,
        });

		this.qaItems.forEach((button) => {

			button.addEventListener('click', () => {
				this.accordionContent = button.previousElementSibling;
				this.accordionItem = button.offsetParent;

				this.accordionContent.classList.toggle('is-active');
				this.accordionItem.classList.toggle('is-extended');

                this.accordionButtonText = button.querySelector('[data-question-answer-text]');
                
				if(this.accordionContent.classList.contains('is-active')) {
                    this.accordionContent.style.height = this.accordionContent.scrollHeight + 'px';
					button.setAttribute('aria-expanded', true);
					this.accordionContent.setAttribute('aria-hidden', false);
					this.accordionButtonText.textContent = 'Verberg antwoord';
                    
                    
				} else {
                    this.accordionContent.style.height = 0 + 'px';
					button.setAttribute('aria-expanded', false);
					this.accordionContent.setAttribute('aria-hidden', true);
					this.accordionButtonText.textContent = 'Bekijk antwoord';
				}

                msnry.layout();
			});

		});
	}
}